import {
  createActionTypes,
  createAsyncAction,
  createAsyncActionTypes,
} from "@dpdgroupuk/redux-action-creator";
import { createLoadingAction } from "../loader/loader.actions";
import {
  fetchWebhookConfiguration,
  generateWebhookSecret,
  revokeWebhookSecret,
  updateWebhookConfiguration,
  fetchSuspendedSecrets,
  reactivateWebhookSecret,
  testWebhook,
} from "./webhook.service";

const ACTION_NAMESPACE = "WEBHOOKS";

export const ACTIONS = createActionTypes(ACTION_NAMESPACE, {
  FETCH_WEBHOOK_CONFIGURATION: createAsyncActionTypes(
    "FETCH_WEBHOOK_CONFIGURATION"
  ),
  GENERATE_WEBHOOK_SECRET: createAsyncActionTypes("GENERATE_WEBHOOK_SECRET"),
  REVOKE_WEBHOOK_SECRET: createAsyncActionTypes("REVOKE_WEBHOOK_SECRET"),
  UPDATE_WEBHOOK_CONFIGURATION: createAsyncActionTypes(
    "UPDATE_WEBHOOK_CONFIGURATION"
  ),
  FETCH_SUSPENDED_SECRETS: createAsyncActionTypes("FETCH_SUSPENDED_SECRETS"),
  REACTIVATE_WEBHOOK_SECRET: createAsyncActionTypes(
    "REACTIVATE_WEBHOOK_SECRET"
  ),
  TEST_WEBHOOK: createAsyncActionTypes("TEST_WEBHOOK"),
  CLEAR_WEBHOOK_CONFIGURATION: "CLEAR_WEBHOOK_CONFIGURATION",
  REMOVE_SUSPENDED_SECRET: "REMOVE_SUSPENDED_SECRET",
  ADD_SUSPENDED_SECRET: "ADD_SUSPENDED_SECRET",
  SET_WEBHOOK_CONFIGURATION_ROW: "SET_WEBHOOK_CONFIGURATION_ROW",
});

export const fetchWebhookConfig = createLoadingAction(
  createAsyncAction(
    fetchWebhookConfiguration,
    ACTIONS.FETCH_WEBHOOK_CONFIGURATION
  )
);

export const generateWebhookSecretAction = createLoadingAction(
  createAsyncAction(generateWebhookSecret, ACTIONS.GENERATE_WEBHOOK_SECRET)
);

export const revokeWebhookSecretAction = createLoadingAction(
  createAsyncAction(revokeWebhookSecret, ACTIONS.REVOKE_WEBHOOK_SECRET)
);

export const updateWebhookConfigurationAction = createLoadingAction(
  createAsyncAction(
    updateWebhookConfiguration,
    ACTIONS.UPDATE_WEBHOOK_CONFIGURATION
  )
);

export const fetchSuspendedSecretsAction = createLoadingAction(
  createAsyncAction(fetchSuspendedSecrets, ACTIONS.FETCH_SUSPENDED_SECRETS)
);

export const reactivateWebhookSecretAction = createLoadingAction(
  createAsyncAction(reactivateWebhookSecret, ACTIONS.REACTIVATE_WEBHOOK_SECRET)
);

export const testWebhookAction = createLoadingAction(
  createAsyncAction(testWebhook, ACTIONS.TEST_WEBHOOK)
);

export const clearWebhookConfiguration = () => ({
  type: ACTIONS.CLEAR_WEBHOOK_CONFIGURATION,
});

export const removeSuspendedSecret = (secretId, type) => ({
  type: ACTIONS.REMOVE_SUSPENDED_SECRET,
  payload: { secretId, type },
});

export const addSuspendedSecret = (secret, type) => ({
  type: ACTIONS.ADD_SUSPENDED_SECRET,
  payload: { secret, type },
});

export const setWebhookConfigurationRow = (configRow) => ({
  type: ACTIONS.SET_WEBHOOK_CONFIGURATION_ROW,
  payload: configRow,
});
